export const DOKUMENT_NAME = {
  // AGBs
  AGB: 'Allgemeine Geschäftsbedingungen',
  SB_ONLINE_BANKING: 'Sonderbedingungen für das Online-Banking',
  SB_LASTSCHRIFT: 'Sonderbedingungen für den Lastschriftverkehr',
  SB_UEBERWEISUNG: 'Sonderbedingungen für den Überweisungsverkehr',
  SB_ECHTZEIT: 'Sonderbedingungen für die Ausführung von Echtzeit-Überweisungen',
  SB_ECHTZEIT_SAMMEL: 'Sonderbedingungen für die Ausführung von Echtzeit-Überweisungen mittels Sammelaufträgen',
  SB_GIROCARD: 'Sonderbedingungen für die girocard (Debitkarte)',
  SB_POSTFACH: 'Sonderbedingungen für die Nutzung des elektronischen Postfachs',

  // Datenschutz & Einwilligung
  DATENSCHUTZ: 'Datenschutzhinweise',
  INFO_EINLEGER: 'Informationsbogen für den Einleger',
  EINWILLIGUNG: 'Einwilligung Mkt Zewcke',
  SCHUFA: 'SCHUFA Klausel',

  // Verträge
  POSTFACH: 'Elektronisches Postfach',
  GIROCARD: 'Girocard',
  KUNDENSTAMM_JUR: 'Kundenstammvertrag fuer jur. Person',
  ONLINEBANKING: 'Onlinebanking',
  KREDIT_KONTO: 'Kreditvertrag Kontokorrentkredite',
  SEPA_FIRMEN: 'SEPA Firmenlastschrift',
  SELBSTAUSKUNFT: 'Selbstauskunft',
  GWG_VERTRAGSPARTNER: 'GWG Vertragspartner',
  GWG_AUFTRETENDER: 'GWG Auftretender',
  KUNDENSTAMM_GBR: 'Kundenstammvertrag GbR',
  UNTERSCHRIFT_GBR: 'Unterschriftsproben GbR',
  KUNDENSTAMM: 'Kundenstamm Vertrag',
  ABTRETUNG: 'Abtretungsvertrag',
  SELECTLIQUID: 'Select Liquid Vollmacht',
} as const;

// Slugs für /documents/rechtliches/<slug>
export const DOKUMENT_SLUG = {
  AGB: 'Allgemeine_Geschaeftsbedingungen',
  SB_ONLINE_BANKING: 'Sonderbedingungen_fuer_das_Online-Banking',
  SB_LASTSCHRIFT: 'Sonderbedingungen_fuer_den_Lastschriftverkehr',
  SB_UEBERWEISUNG: 'Sonderbedingungen_fuer_den_Ueberweisungsverkehr',
  SB_ECHTZEIT: 'Sonderbedingungen_fuer_die_Ausfuehrung_von_Echtzeit-Ueberweisungen',
  SB_ECHTZEIT_SAMMEL: 'Sonderbedingungen_fuer_die_Ausfuehrung_von_Echtzeit-Ueberweisungen_mittels_Sammelauftraegen',
  SB_GIROCARD: 'Sonderbedingungen_fuer_die_girocard_(Debitkarte)',
  SB_POSTFACH: 'Sonderbedingungen_fuer_die_Nutzung_des_elektronischen_Postfachs',

  DATENSCHUTZ: 'Datenschutzhinweise',
  INFO_EINLEGER: 'Informationsbogen für den Einleger',
  SCHUFA: 'SCHUFA Klausel',
  EINWILLIGUNG: 'Einwilligung Mkt Zewcke',
} as const;

// Nummern-Mapping für Verträge (getDocument)
// 8 (SEPA) ist absichtlich nicht fix, weil konditional.
export const VERTRAEGE_BY_NR: Record<number, keyof typeof DOKUMENT_NAME> = {
  1: 'POSTFACH',
  2: 'GIROCARD',
  4: 'KUNDENSTAMM_JUR',
  5: 'ONLINEBANKING',
  6: 'KREDIT_KONTO',
  9: 'SELBSTAUSKUNFT',
  10: 'GWG_VERTRAGSPARTNER',
  11: 'GWG_AUFTRETENDER',
  12: 'KUNDENSTAMM_GBR',
  13: 'UNTERSCHRIFT_GBR',
  14: 'KUNDENSTAMM',
  15: 'ABTRETUNG',
  16: 'SELECTLIQUID',
};

// Nummern-Mapping für Rechtliches (getRechtlichesDocument)
export const RECHTLICHES_BY_NR: Record<number, keyof typeof DOKUMENT_SLUG> = {
  1: 'AGB',
  2: 'SB_ONLINE_BANKING',
  3: 'SB_LASTSCHRIFT',
  4: 'SB_UEBERWEISUNG',
  5: 'SB_ECHTZEIT',
  6: 'SB_ECHTZEIT_SAMMEL',
  7: 'SB_GIROCARD',
  8: 'SB_POSTFACH',
  9: 'DATENSCHUTZ',
  11: 'INFO_EINLEGER',
  12: 'SCHUFA',
  13: 'EINWILLIGUNG',
};
